/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentCategoryOption
 */
export interface TournamentCategoryOption {
    /**
     * Internal key (e.g., TOURNAMENT, MONEY_MATCH, LEAGUE)
     * @type {string}
     * @memberof TournamentCategoryOption
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategoryOption
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentCategoryOption
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentCategoryOption
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentCategoryOption
     */
    sortOrder: number;
}

/**
 * Check if a given object implements the TournamentCategoryOption interface.
 */
export function instanceOfTournamentCategoryOption(value: object): value is TournamentCategoryOption {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function TournamentCategoryOptionFromJSON(json: any): TournamentCategoryOption {
    return TournamentCategoryOptionFromJSONTyped(json, false);
}

export function TournamentCategoryOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCategoryOption {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'enabled': json['enabled'],
        'sortOrder': json['sortOrder'],
    };
}

export function TournamentCategoryOptionToJSON(json: any): TournamentCategoryOption {
    return TournamentCategoryOptionToJSONTyped(json, false);
}

export function TournamentCategoryOptionToJSONTyped(value?: TournamentCategoryOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'description': value['description'],
        'enabled': value['enabled'],
        'sortOrder': value['sortOrder'],
    };
}

